import styles from './HighlightFooter.module.scss';
import CorticoLogo from '../Logos/CorticoLogo';
import { Highlight } from '../HighlightCard/HighlightCard';
import {
  CopyLinkLogo,
  EmailLogo,
  LinkedInLogo,
  TwitterLogo,
} from '../Logos/SocialLogos';
import StylelessButton from '../StylelessButton/StylelessButton';
import { useRef } from 'react';

interface Props {
  highlight: Highlight | null;
}

const HighlightFooter = ({ highlight }: Props) => {
  const linkRef = useRef<HTMLDivElement>(null);

  function showCopiedConfirmation() {
    if (!linkRef.current) {
      return;
    }
    const linkRect = linkRef.current.getBoundingClientRect();
    const bottom = linkRect.bottom;
    const left = linkRect.left - 25;
    const confirmationMessage = document.createElement('div');
    confirmationMessage.innerText = 'Copied!';
    confirmationMessage.style.position = 'fixed';
    confirmationMessage.style.top = `${bottom}px`;
    confirmationMessage.style.left = `${left}px`;
    confirmationMessage.style.backgroundColor = '#333';
    confirmationMessage.style.color = '#fff';
    confirmationMessage.style.padding = '10px 15px';
    confirmationMessage.style.borderRadius = '5px';
    confirmationMessage.style.zIndex = '9999';
    document.body.appendChild(confirmationMessage);

    setTimeout(() => {
      confirmationMessage.remove();
    }, 2000); // Remove after 2 seconds
  }

  const handleSocialClick = (
    platform: 'linkedin' | 'twitter' | 'instagram' | 'email' | 'copy_link'
  ) => {
    switch (platform) {
      case 'linkedin':
        window.open(
          `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
            window.location.href
          )}`,
          '_blank'
        );
        break;
      case 'twitter':
        window.open(
          `https://twitter.com/share?url=${encodeURIComponent(
            window.location.href
          )}`,
          '_blank'
        );
        break;
      case 'instagram':
        window.open(
          `https://www.instagram.com/share?url=${encodeURIComponent(
            window.location.href
          )}`,
          '_blank'
        );
        break;
      case 'email':
        window.open(
          `mailto:?subject=[Listen to this Highlight on Cortico]&body=${encodeURIComponent(
            window.location.href
          )}`,
          '_blank'
        );
        break;
      case 'copy_link':
        navigator.clipboard.writeText(window.location.href).then(() => {
          showCopiedConfirmation();
        });
        break;
    }
  };

  return (
    <div className={styles.footer}>
      <div className={styles.leftFooter}>
        <StylelessButton
          className={styles.socialButton}
          onClick={() => handleSocialClick('linkedin')}
        >
          <LinkedInLogo />
        </StylelessButton>
        <StylelessButton
          className={styles.socialButton}
          onClick={() => handleSocialClick('twitter')}
        >
          <TwitterLogo />
        </StylelessButton>
        {/* <StylelessButton
          className={styles.socialButton}
          onClick={() => handleSocialClick('instagram')}
        >
          <InstagramLogo />
        </StylelessButton> */}
        <StylelessButton
          className={styles.socialButton}
          onClick={() => handleSocialClick('email')}
        >
          <EmailLogo />
        </StylelessButton>
        <div ref={linkRef}>
          <StylelessButton
            className={styles.socialButton}
            onClick={() => handleSocialClick('copy_link')}
          >
            <CopyLinkLogo />
          </StylelessButton>
        </div>
      </div>
      <div>
        <a
          href="https://cortico.ai"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.logo}
        >
          <p>Powered by</p>
          <CorticoLogo width={150} />
        </a>
      </div>
    </div>
  );
};

export default HighlightFooter;
